module.exports = __webpack_public_path__ + "static/media/edge_en.d4dd75d5.png";